import { render, staticRenderFns } from "./LoadingFilePanel.vue?vue&type=template&id=3ba364e4&scoped=true"
import script from "./LoadingFilePanel.vue?vue&type=script&lang=ts"
export * from "./LoadingFilePanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LoadingFilePanel.vue?vue&type=style&index=0&id=3ba364e4&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3ba364e4",
  null
  ,true
)

export default component.exports